/**
 * Location - Photo Destination module
 *
 * @author MattJS (matt@yext.com)
 */
goog.provide('yext.location.photodestination');
goog.provide('yext.location.PhotoDestination');

/** @suppress {extraRequire} */
goog.require('yext.plugins.contextualHelp');

yext.location.photodestination.$iconTemplate = undefined;
yext.location.photodestination.$iconAllTemplate = undefined;
yext.location.photodestination.$containerTemplate = undefined;

// Maps PhotoDestination objects to elements
yext.location.photodestination.destinationMap = {};
yext.location.photodestination.UID = 1;
yext.location.photodestination.UIDString = 'photoDestinationUID';

/**
 * Photo Destination class
 *
 * @constructor
 * @param {!Array} destinations List of destinations for a photo
 */
yext.location.PhotoDestination = function(destinations) {
  this.$container = yext.location.photodestination.$containerTemplate.clone();
  this.$iconAll = yext.location.photodestination.$iconAllTemplate.clone().addClass('edit-mode');

  this.destinations = destinations;
  this.destinationCount = 0;
  this.$icons = {};

  // Set UID and store in map
  this.UID = yext.location.photodestination.UID++;
  this.$container.data(yext.location.photodestination.UIDString, this.UID);
  yext.location.photodestination.destinationMap[this.UID] = this;

  this.build();
  this.bind();
  this.render();
};

/**
 * Build photo destination markup
 */
yext.location.PhotoDestination.prototype.build = function() {
  this.$container.append(this.$iconAll);

  for (var i = 0; i < yext.location.photodestination.destinations.length; i++) {
    var selected = this.destinations.indexOf(yext.location.photodestination.destinations[i].value) != -1;
    if (selected || yext.location.photodestination.destinations[i].eligible) {
      var $icon = yext.location.photodestination.$iconTemplate.clone();

      this.destinationCount++;

      $icon
        .html(yext.location.photodestination.destinations[i].shorthand)
        .addClass('edit-mode')
        .data('value', yext.location.photodestination.destinations[i].value)
        .contextualHelp({
          width: 'auto',
          event: 'hover',
          fade: true,
          hoverDelay: 100,
          basicText: yext.location.photodestination.destinations[i].readable,
        });

      this.$container.append($icon);

      this.$icons[yext.location.photodestination.destinations[i].value] = $icon;
    }
  }
  if (!this.destinationCount) {
    this.$container.hide();
  }
};

/**
 * Bind click events
 */
yext.location.PhotoDestination.prototype.bind = function() {
  var self = this;

  this.$iconAll.click(function() {
    self.clearDestinations();
  });

  this.$container.on('click', '.js-pd-icon', function() {
    self.toggleDestination($(this).data('value'));
  });
};

/**
 * Clear out destinations (set to all)
 */
yext.location.PhotoDestination.prototype.clearDestinations = function() {
  this.destinations = [];
  this.broadcast();
  this.render();
};

/**
 * Add a destination
 *
 * @param {string} value String representing the destination
 */
yext.location.PhotoDestination.prototype.addDestination = function(value) {
  if (this.destinations.indexOf(value) == -1) {
    if (this.destinations.length + 1 != this.destinationCount) {
      this.destinations.push(value);
      this.broadcast();
      this.render();
    } else {
      this.clearDestinations();
    }
  }
};

/**
 * Toggle a destination
 *
 * @param {string} value String representing the destination
 */
yext.location.PhotoDestination.prototype.toggleDestination = function(value) {
  if (this.destinations.indexOf(value) == -1) {
    this.addDestination(value);
  } else {
    this.removeDestination(value);
  }
};

/**
 * Remove a destination
 *
 * @param {string} value String representing the destination
 */
yext.location.PhotoDestination.prototype.removeDestination = function(value) {
  var index = this.destinations.indexOf(value);
  if (index != -1) {
    this.destinations.splice(index, 1);
    this.broadcast();
    this.render();
  }
};

/**
 * Set the destinations
 *
 * @param {!Array} destinations Array of destinations for updating the UI
 * programmatically
 */
yext.location.PhotoDestination.prototype.set = function(destinations) {
  if (yext.location.photodestination.different(this.destinations, destinations)) {
    this.destinations = destinations.slice(0); // Copy by value
    this.broadcast();
    this.render();
  }
};

/**
 * Render the photo destination UI
 */
yext.location.PhotoDestination.prototype.render = function() {
  this.$container.find('.js-pd-icon').removeClass('selected');
  this.$iconAll.toggleClass('selected', !this.destinations.length);

  for (var i = 0; i < this.destinations.length; i++) {
    this.$icons[this.destinations[i]].addClass('selected');
  }
};

/**
 * Broadcast a change to the photo destinations
 */
yext.location.PhotoDestination.prototype.broadcast = function() {
  $(this).trigger('update.photoDestination', this.destinations);
};

/**
 * Cleanup to prevent memory leaks
 */
yext.location.PhotoDestination.prototype.destroy = function() {
  delete yext.location.photodestination.destinationMap[this.UID];
  $(this).off('.photoDestination');
};

/**
 * Checks that two lists of destinations are different. Agnostic to order
 *
 * @param {array} dest1 Array of destinations
 * @param {array} dest2 Array of destinations
 * @return {boolean} True if the arrays are different
 */
yext.location.photodestination.different = function(dest1, dest2) {
  var change = dest1.length != dest2.length;
  if (!change) {
    for (var i = 0; i < dest1.length; i++) {
      if (dest2.indexOf(dest1[i]) == -1) {
        return true;
      }
    }
  }
  return change;
};

/**
 * Generate view markup
 *
 * @param {!Array} destinations Array of destinations for which to to create
 * view markup
 * @return {!jQuery} Photo destination view markup
 */
yext.location.photodestination.viewMarkup = function(destinations) {
  var $container = yext.location.photodestination.$containerTemplate.clone().empty();

  if (!destinations || !destinations.length) {
    $container.append(yext.location.photodestination.$iconAllTemplate.clone());
  } else {
    for (var i = 0; i < destinations.length; i++) {
      var $icon = yext.location.photodestination.$iconTemplate.clone();
      $icon.html(yext.location.photodestination.getDestination(destinations[i]).shorthand);
      $container.append($icon);
    }
  }

  return $container;
};

/**
 * Get detains about a destination based upon its enum string
 *
 * @param {string} destination String representing the destination
 */
yext.location.photodestination.getDestination = function(destination) {
  for (var i = 0; i < yext.location.photodestination.destinations.length; i++) {
    if (yext.location.photodestination.destinations[i].value == destination) {
      return yext.location.photodestination.destinations[i];
    }
  }
};

/**
 * Initialize module by cloning templates and providing destination details
 *
 * @param {!Array} destinations List of all possible destinations and details
 * including readable versions, shorthands, and whether the business is
 * eligible to deliver a photo to that destination
 */
yext.location.photodestination.init = function(destinations) {
  if (Object.prototype.toString.call(destinations) !== '[object Array]') {
    destinations = [];
  }
  yext.location.photodestination.destinations = destinations;

  yext.location.photodestination.$iconTemplate = $($('.js-pd-icon-template').html());
  yext.location.photodestination.$iconAllTemplate = $($('.js-pd-icon-all-template').html());
  yext.location.photodestination.$containerTemplate = $($('.js-pd-container-template').html());
};
goog.exportSymbol('yext.location.photodestination.init', yext.location.photodestination.init);

/**
 * Create photo destination instance
 *
 * @param {!Array} destinations List of destinations for which a photo is
 * being delivered or eligible
 * @return {yext.location.PhotoDestination} Instance of photo destination object
 */
yext.location.photodestination.create = function(destinations) {
  if (!destinations) {
    destinations = []; // Default to empty array
  } else {
    destinations = destinations.slice(0); // Copy by value
  }
  return new yext.location.PhotoDestination(destinations);
};

/**
 * Get photo destination by element
 *
 * @param {!jQuery} $container The dom that wraps the destinations
 * @return {yext.location.PhotoDestination} Instance of PhotoDestination object
 */
yext.location.photodestination.get = function($container) {
  return yext.location.photodestination.destinationMap[$container.data(yext.location.photodestination.UIDString)];
};
